import { ApiResponse } from 'store/interfaces';

export enum ScheduleEmployeeType {
  normal = 'normal',
  exception = 'exception',
}

export interface ScheduleEmployee {
  '@id': string;
  id: string;
  employee: string;
  schedule: string;
  dateFrom: string;
  dateTo: string | null;
  type: ScheduleEmployeeType;
}

export interface ScheduleEmployeesData extends ApiResponse {
  'hydra:member': ScheduleEmployee[];
}

export interface ScheduleEmployeeFilters {
  page: number;
  itemsPerPage: number;
  employee: string | string[];
  'dateFrom[before]': string;
  'dateFrom[after]': string;
  'dateFrom[strictly_after]': string;
  'dateFrom[strictly_before]': string;
  'dateTo[before]': string;
  'dateTo[after]': string;
  'dateTo[strictly_after]': string;
  'dateTo[strictly_before]': string;
}

export interface ScheduleEmployeePostMutationRequest
  extends Pick<
    ScheduleEmployee,
    'employee' | 'schedule' | 'dateFrom' | 'type'
  > {
  dateTo?: string;
}

export interface ScheduleEmployeePatchMutationRequest
  extends Partial<ScheduleEmployeePostMutationRequest> {
  id: string;
}
